import React from "react";
import { FallbackProps } from "react-error-boundary";
import { Container, Box, Typography, Stack, Button } from "@mui/material";
import { LG } from "../../styles/liquidGlass";

export const AppErrorFallback: React.FC<FallbackProps> = () => {
    return (
        <Container maxWidth="md" sx={{ py: 6 }}>
            <Box
                sx={{
                    p: 4,
                    background: LG.color.surfaceStrong,
                    backdropFilter: LG.blur,
                    WebkitBackdropFilter: LG.blur,
                    border: `1px solid ${LG.color.border}`,
                    borderRadius: LG.radius.lg,
                    boxShadow: LG.shadow.md,
                }}
            >
                <Typography
                    sx={{
                        fontSize: "20px",
                        fontWeight: 700,
                        fontFamily: "inherit",
                        color: LG.color.text,
                        letterSpacing: "0.04em",
                        mb: 1.5,
                    }}
                    gutterBottom
                >
                    Ocurrió un error inesperado
                </Typography>

                <Typography
                    sx={{
                        fontFamily: "inherit",
                        fontSize: "0.9rem",
                        color: LG.color.textSecondary,
                        mb: 3,
                    }}
                >
                    Se registró este problema a nuestro equipo y ya está trabajando para solucionarlo.
                </Typography>

                <Stack direction="row" justifyContent="center">
                    <Button
                        variant="contained"
                        sx={{
                            background: LG.color.buttonDark,
                            color: LG.color.buttonDarkText,
                            borderRadius: LG.radius.pill,
                            fontWeight: 700,
                            letterSpacing: "0.06em",
                            fontFamily: "inherit",
                            py: 1.5,
                            px: 4,
                            "&:hover": { background: "#000" },
                        }}
                        onClick={() => (window.location.href = "/")}
                    >
                        VOLVER AL INICIO
                    </Button>
                </Stack>
            </Box>
        </Container>
    );
};
